import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { NgModel } from '@angular/forms';

@Component({
    selector: 'fi-color-palette-picker',
    templateUrl: './fi-color-palette-picker.component.html',
    styleUrls: ['./fi-color-palette-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-color-palette-picker' },
    standalone: false,
})
export class FiColorPalettePickerComponent implements OnChanges {
    @Input() color: string;
    @Output() colorChange = new EventEmitter<string>();
    @ViewChild('colorInputModel', { static: false }) colorInputModel: NgModel;

    readonly presetColors = [
        '1abc9c',
        '2ecc71',
        '3498db',
        '9b59b6',
        '34495e',
        '16a085',
        '27ae60',
        '2980b9',
        '8e44ad',
        '2c3e50',
        'f1c40f',
        'e67e22',
        'e74c3c',
        'ecf0f1',
        '95a5a6',
        'f39c12',
        'd35400',
        'c0392b',
        'bdc3c7',
        '7f8c8d',
    ];
    colorInput: string;

    constructor() {}

    onChange() {
        this.colorChange.emit(this.color);
    }

    // make all validation before calling this method
    setBrandingColor(color: string) {
        this.color = color;
        this.onChange();
    }

    colorInputChange() {
        if (this.colorInput) {
            const origValue: string = this.colorInput;
            const matches: RegExpMatchArray = origValue.match(/^(#?)([0-9a-f]{6})$/i);
            if (matches) {
                if (origValue === matches[2]) {
                    this.setBrandingColor(this.colorInput);
                } else {
                    this.colorInputModel.control.setValue(matches[2]);
                }
            }
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.color) {
            this.colorInput = changes.color.currentValue;
        }
    }
}
